import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type StoryList = paths['/v3/story/{type}/'];

const getStoryList = createRequest<StoryList>('/pc/v3/story/{type}/');

export default getStoryList;
